import { setLocale, TestMessageParams } from "yup";
import i18n from "utilities/i18n";

/**
 * Add i18n namespace of "validations" to params.  This will use translations
 * from validations.json.
 */
const nsParams = (params: Partial<TestMessageParams>) => {
  return { ...params, ns: "validations" };
};

setLocale({
  mixed: {
    default: params => i18n.t("mixed.default", nsParams(params)),
    required: params => i18n.t("mixed.required", nsParams(params)),
    oneOf: params => i18n.t("mixed.oneOf", nsParams(params)),
    notOneOf: params => i18n.t("mixed.notOneOf", nsParams(params)),
    notType: params => i18n.t("mixed.notType", nsParams(params))
  },
  string: {
    email: params => i18n.t("string.email", nsParams(params)),
    length: params => i18n.t("string.length", nsParams(params)),
    lowercase: params => i18n.t("string.lowercase", nsParams(params)),
    matches: params => i18n.t("string.matches", nsParams(params)),
    max: params => i18n.t("string.max", nsParams(params)),
    min: params => i18n.t("string.min", nsParams(params)),
    trim: params => i18n.t("string.trim", nsParams(params)),
    uppercase: params => i18n.t("string.uppercase", nsParams(params)),
    url: params => i18n.t("string.url", nsParams(params))
  },
  array: {
    max: params => i18n.t("array.max", nsParams(params)),
    min: params => i18n.t("array.min", nsParams(params))
  },
  object: {
    noUnknown: params => i18n.t("object.noUnknown", nsParams(params))
  },
  date: {
    max: params => i18n.t("date.max", nsParams(params)),
    min: params => i18n.t("date.min", nsParams(params))
  },
  number: {
    min: params => i18n.t("number.integer", nsParams(params)),
    max: params => i18n.t("number.integer", nsParams(params)),
    lessThan: params => i18n.t("number.integer", nsParams(params)),
    moreThan: params => i18n.t("number.integer", nsParams(params)),
    positive: params => i18n.t("number.integer", nsParams(params)),
    negative: params => i18n.t("number.integer", nsParams(params)),
    integer: params => i18n.t("number.integer", nsParams(params))
  }
});
